import { MOS_RESULT_MAP, TEST_RESULT } from "@/modules/calls/enums";
import { TEST_RESULT_MESSAGES } from "@/modules/calls/const";

export default {
  /**
   * Set connectivity test progress
   * @param {Object} state
   * @param {Boolean} isInProgress
   */
  setTestProgress(state, isInProgress) {
    state.isTestInProgress = isInProgress;
  },
  /**
   * Set connectivity test result
   * @param {Object} state
   * @param {String} status
   */
  setTestResult(state, status) {
    state.testResult = status;
  },
  /**
   * Set connectivity test result message
   * @param {Object} state
   * @param {String} message
   */
  setTestResultMessage(state, message) {
    state.testResultMessage = message;
  },
  /**
   * Set connectivity test result message
   * @param {Object} state
   * @param {Object|null} data
   */
  setTestResultData(state, data) {
    if (!data || !data.video || !data.audio) {
      return;
    }

    const MOS = Math.round(Math.min(data.video.mos, data.audio.mos));
    state.testResult = MOS_RESULT_MAP[MOS];
    state.testResultMessage = TEST_RESULT_MESSAGES.READY;

    if (data.video.reason) {
      state.testResultMessage = `Video is not supported: ${data.video.reason}`;
    }

    if (!data.audio.supported) {
      state.testResultMessage = "Audio is not supported.";
    }

    if (!data.audio.supported && !data.video.supported) {
      state.testResult = TEST_RESULT.ERROR;
      state.testResultMessage = "Audio and video sources are not available.";
    }

    state.testResultData = data;
  },
  /**
   * Clear test result data
   * @param {Object} state
   */
  clearTestResultData(state) {
    state.testResultData = null;
    state.testResult = TEST_RESULT.READY;
    state.testResultMessage = TEST_RESULT_MESSAGES.READY;
  }
};
